import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

function KpiBlock({ component }) {
  const { iconMedia, title, subtitle, backgroundColor, kpis } = component

  return (
    <div
      className={`pt-12 ${
        backgroundColor === "blue" ? "bg-charlestonGreen-100" : "bg-white"
      }`}
    >
      <div className="px-4 pt-8 pb-8 mx-auto max-w-7xl sm:pt-16 sm:px-6 lg:px-8">
        <div className="text-center">
          {iconMedia?.localFile?.childImageSharp && (
            <GatsbyImage
              className="w-10 h-8 mb-6"
              image={iconMedia?.localFile.childImageSharp.icon}
              alt={iconMedia.altText || ""}
            />
          )}
          {title && (
            <h2 className="text-3xl lg:text-4xl font-bold mb-3 text-charlestonGreen-500">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className={`text-xl text-charlestonGreen-500 mb-3 `}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <div className="relative">
        <div className="px-4 pb-16 mx-auto sm:px-6 max-w-7xl sm:pb-24 flex flex-wrap lg:flex-nowrap justify-around gap-4">
          {kpis.map(k => (
            <div key={k.kpi + k.kpiSubtitle}>
              <h3 className="text-xl tracking-tight mb-3">
                <span className="text-4xl font-extrabold block text-center text-blue-400">
                  {k.kpi}
                </span>
                <span className="block text-center">{k.kpiSubtitle}</span>
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default KpiBlock
